import React from 'react'

const AdCreativeDetailsForm = ({ ad = {} }) => {

    return (
        <>
            <div className="mt-2 fw-bold text-secondary ">Ad Details</div>
            <div className="border shadow-sm rounded bg-white p-3">
                <div className="row g-3">
                    {/* Render non-creatives fields first */}
                    {Object.entries(ad).filter(([key]) =>
                        !["_id", "SID", "addOn", "addBy", "companyId", "modOn", "modBy", "creatives"].includes(key)
                    ).map(([key, value], index) => {
                        const displayValue = typeof value === "object" ? value?.Description || value?.Name || JSON.stringify(value) : value;
                        return (
                            <div key={`field-${index}`} className="col-12 col-sm-6 col-md-4 col-lg-3 mt-2">
                                <div className="bg-light border rounded p-2 h-100">
                                    <p className="text-uppercase text-muted  mb-1 fw-semibold">{key}</p>
                                    <p className="text-dark  mb-0 text-break">{displayValue}</p>
                                </div>
                            </div>
                        );
                    })}

                    {/* Render creatives (attachments) last */}
                    {"creatives" in ad && Array.isArray(ad.creatives) && (
                        <div className="col-12 mt-2">
                            <p className="text-uppercase text-muted small fw-semibold mb-2">Attachments</p>
                            <div className="d-flex flex-wrap gap-2 bg-light p-2 rounded">
                                {ad.creatives.map((creative, idx) => {
                                    const format = creative?.format?.toLowerCase();
                                    const isVideo = format === "mp4" || format === "mov";

                                    return (
                                        <div
                                            key={`creative-${idx}`}
                                            className="border rounded overflow-hidden"
                                            style={{ width: "80px", height: "80px" }}
                                        >
                                            {isVideo ? (
                                                <video
                                                    src={creative?.url}
                                                    className="w-100 h-100 object-fit-cover"
                                                    controls
                                                    muted
                                                />
                                            ) : (
                                                <img
                                                    src={creative?.url}
                                                    alt={creative?.fileName || `Attachment ${idx + 1}`}
                                                    className="img-fluid w-100 h-100 object-fit-cover"
                                                />
                                            )}
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default AdCreativeDetailsForm